import { connect } from 'react-redux';

import { unlockParticipantClip } from 'api/events/events.actions';
import { UnlockClipModalContent } from './UnlockClipModalContent';
import { UnlockParticipantClipBody } from 'api/events/events.types';

const mapDispatchToProps = (dispatch: Function) => ({
  unlockParticipantClip: (eventId: string, body: UnlockParticipantClipBody) =>
    dispatch(unlockParticipantClip(eventId, body)),
});

export const UnlockClipModalContentContainer = connect(null, mapDispatchToProps)(UnlockClipModalContent);
